export const CONFIG_API_URL = 'upload_config';

export const CONFIG_QUERY_KEY = 'config';
